import {decode as base64_decode, encode as base64_encode} from 'base-64';
import jwt_decode from "jwt-decode";


class Dependencies{
    
    decodePaymentToken (payment_token){
        // decode from base64 format
        let base64 = base64_decode(payment_token);
        // decode from jwt format
        let jwt = jwt_decode(base64);
        return jwt
    }

}

export let dependencies = new Dependencies();